import axios from 'axios';
import lang from '@/i18n/locale.js';
const qs = require('qs');
import { baseURL } from '../config'

const options = {
  withCredentials: true,
  baseURL,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  // headers: { 'Content-Type': 'application/json' },
  timeout: 3 * 60 * 1000 // request timeout
};

// create an axios instance
const request = axios.create(options);

request.interceptors.request.use(
  (config) => {
    config.params = {
      ...config.params,
      lang: lang.lang_type == 'cn' ? 'zh' : 'en'
    };
    if (
      config.method == 'post' &&
      config._dataType != 'file' &&
      config._dataType != 'json'
    ) {
      config.data = qs.stringify(config.data);
    }
    // console.log(config);
    return config;
  },
  (error) => {
    console.log(error); // for debug
    Promise.reject(error);
  }
);

request.interceptors.response.use(
  (res) => {
    try {
      if (res.status == 200) {
        return res.data;
      } else {
        return Promise.reject();
      }
    } catch (error) {
      return Promise.reject();
    }
  },
  (error) => {
    return Promise.reject();
  }
);

export default request;
